import { render, staticRenderFns } from "./blankView.vue?vue&type=template&id=15beacdc&"
import script from "./blankView.vue?vue&type=script&lang=ts&"
export * from "./blankView.vue?vue&type=script&lang=ts&"
import style0 from "./blankView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports